import { get } from '.';


export function GetFormattedRoOrderDetailsFromXML(id: number) {
    return get<any>(`/app/api/dms_processing_record/${id}`)
}